import { render } from "./Tarefa.vue?vue&type=template&id=97674acc"
import script from "./Tarefa.vue?vue&type=script&lang=js"
export * from "./Tarefa.vue?vue&type=script&lang=js"

import "./Tarefa.vue?vue&type=style&index=0&id=97674acc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__